module.exports = __webpack_public_path__ + "img/hair-color-3@2x.2a0ba6b8.jpg";